import { copyString } from '@amp/web-app-components/src/utils/copyString';

export const canShareLink = (url: string): boolean =>
    navigator?.canShare && navigator.canShare({ url });

const shareLink = async (data: {
    title?: string;
    url: string;
}): Promise<void> => {
    const url = data.url;
    if (canShareLink(url)) {
        return navigator
            .share(data)
            .then(() => console.info('Share was successful.'))
            .catch(() =>
                console.warn('Sharing failed. Did you close the share dialog?'),
            );
    } else {
        console.warn('Sharing is not supported.');
        return Promise.reject('Sharing is not supported.');
    }
};

export const copyLink = async (data: {
    title?: string;
    url: string;
}): Promise<{ copied?: boolean }> => {
    copyString(data.url);

    return {
        copied: true,
    };
};

export const shareLinkOrCopy = async (data: {
    title?: string;
    url: string;
}): Promise<{ shared?: boolean; copied?: boolean }> => {
    try {
        await shareLink(data);

        return {
            shared: true,
        };
    } catch (error) {
        return copyLink(data);
    }
};
